// TimeField.js
import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import moment from 'moment';

const ReusableField = ({ label, value, fieldType }) => {
    // Format the value based on fieldType
    const formatValue = () => {
        if (fieldType === 'text') {
            return value;
        } else if (fieldType === 'timefield') {
            return value ? moment(value, "YYYYMMDDHHmmss").format("MM/DD/YYYY HH:mm:ss") : "";
        }
        return "";
    };

    return (
        <Box
            sx={{
                width: "100%",
                boxSizing: "border-box",
                marginBottom: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
            }}
        >
            <Typography
                sx={{
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                    lineHeight: "24px",
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    verticalAlign: "top",
                    fontSize: "13px", // Reduced font size
                }}
            >
                {label}
            </Typography>

            <Typography
                sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.5px",
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    verticalAlign: "top",
                    fontSize: "13px", // Reduced font size
                }}
            >
                {formatValue()}
            </Typography>
        </Box>
    );
};

export default ReusableField;